export function getCardPNGID(cardTitle: string, nodeID?: number) {
  if (nodeID) {
    return `${cardTitle.toLowerCase().replace(/[^a-zA-Z]/g, "")}_${nodeID}`;
  }
  return cardTitle.toLowerCase().replace(/[^a-zA-Z]/g, "");
}
